import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminoscondiciones',
  templateUrl: './terminoscondiciones.component.html',
  styleUrls: ['./terminoscondiciones.component.css']
})
export class TerminoscondicionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
